<template>
  <HXContentCard title="Nueva Marca" :toBack="{ name: 'Marcas' }">
    <form @submit.prevent="saveData">
      <div class="row px-5 mt-4">
        <div class="col-md-6">
          <div>
            <label for=" " class="form-label">Nombre Marca</label>
            <input v-model="item.descripcion" required placeholder="Escriba el Nombre de la Marca..." type="text"
              class="form-control" id=" " />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for=" " class="form-label">Empresa</label>
            <b-form-select :disabled="usuario.rol.nivel != 4 ? true : false" required v-model="item.EmpresaId"
              :options="ListEmpresas" text-field="nombre" value-field="id"></b-form-select>
          </div>
        </div>
      </div>
      <div class="text-right px-5 pb-4 d-flex justify-content-end">
        <vs-button icon animation-type="vertical" type="submit">
          <i class="fas fa-save pr-1"></i>
          Guardar Marca
          <template #animate>
            <i class="fas fa-save"></i>
          </template>
        </vs-button>
      </div>
    </form>
  </HXContentCard>
</template>
<script>
export default {
  data() {
    return {
      item: { descripcion: "", EmpresaId: "", Estado: 1 },
      ListEmpresas: [],
      selected: null,
      empresaSelected: null,
      usuario: {},
    };
  },
  async mounted() {
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    console.log("usuario ", this.usuario);
    this.item.EmpresaId = this.usuario.empresa.id;

    await this.getEmpresas();
  },
  methods: {
    async getEmpresas() {
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Empresa/ListEmpresa/",
        });
        this.ListEmpresas = res;

        console.log("list", this.ListEmpresas);
      } catch (error) {
        this.ListEmpresas = {};
        console.log("err", error);
      }
    },
    async saveData() {
      this.isCreating = true;
      console.log("saving", this.item);

      try {
        const res = await this.$store.dispatch("hl_post", {
          path: "Marca/CreateMarca/",
          data: this.item,
        });

        console.log("post empresas...", res);

        if (res) {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-check-circle'></i>`,
            color: "success",
            position: "top-right",
            title: "Éxito",
            text: "¡Marca creada exitosamente!",
          });

          this.$router.push("/helex/Marcas");
        } else {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-exclamation-triangle'></i>`,
            color: "warning",
            position: "top-right",
            title: "Advertencia",
            text: "No se pudo guardar la información. Verifica los datos.",
          });
        }
      } catch (error) {
        console.error("err", error);

        this.$vs.notification({
          progress: "auto",
          icon: `<i class='fas fa-times-circle'></i>`,
          color: "danger",
          position: "top-right",
          title: "Error",
          text: "Ocurrió un error al crear la marca.",
        });

        this.item = {};
      } finally {
        this.isCreating = false;
      }
    },

  },
};
</script>
